jQuery(document).ready(function(){

    $('[data-toggle="tooltip"]').tooltip()
    
    // copy text
    $('.copyToClipboard .btn').on('click', function() {
        var txtKey = $(this).attr('data-content');

        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val(txtKey).select();
        document.execCommand("copy");
        $temp.remove();
        $(this).text("Copiado!");
        $(this).removeClass('btn-outline-secondary');
        $(this).addClass('btn-outline-success');
        
        setTimeout(() => {
            $(this).text("Copiar");
            $(this).addClass('btn-outline-secondary');
            $(this).removeClass('btn-outline-success');
        }, 1500);
    });

    /**
     * is change
     */
     $('.form-is-change').on('input change', function() {
        $('.form-is-change button[type="submit"]').attr('disabled', false);
    });

    /**
     * validate
     */
    $('#createUsrForm').validate({
        rules: {
            name: {
                required: true,
                minlength: 6
            },
            email: {
                required: true,
                email: true
            },
            password: {
                required: true,
                minlength: 8
            },
        },
        // messages: {
        //     name: {
        //         required: "Please enter a email address",
        //         minlength: "Your password must be at least 8 characters long"
        //     },
        //     email: {
        //         required: "Please enter a email address",
        //         email: "Please enter a valid email address"
        //     },
        //     password: {
        //         required: "Please provide a password",
        //         minlength: "Your password must be at least 8 characters long"
        //     },
        // },
        errorElement: 'span',
        errorPlacement: function (error, element) {
            error.addClass('invalid-feedback');
            element.closest('.form-group').append(error);
        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid');
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid');
        }
    });
    $('#myAccountForm').validate({
        rules: {
            name: {
                required: true,
                minlength: 6
            },
            email: {
                required: true,
                email: true
            }
        },
        errorElement: 'span',
        errorPlacement: function (error, element) {
            error.addClass('invalid-feedback');
            element.closest('.form-group').append(error);
        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid');
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid');
        }
    });
    $('#editUsrForm').validate({
        rules: {
            name: {
                required: true,
                minlength: 6
            },
            email: {
                required: true,
                email: true
            }
        },
        errorElement: 'span',
        errorPlacement: function (error, element) {
            error.addClass('invalid-feedback');
            element.closest('.form-group').append(error);
        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid');
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid');
        }
    });
    $('#createKeyForm').validate({
        rules: {
            name: {
                required: true,
                minlength: 5
            }
        },
        errorElement: 'span',
        errorPlacement: function (error, element) {
            error.addClass('invalid-feedback');
            element.closest('.form-group').append(error);
        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid');
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid');
        }
    });
    $('#loadCerForm').validate({
        rules: {
            password: {
                required: true
            }
        },
        errorElement: 'span',
        errorPlacement: function (error, element) {
            error.addClass('invalid-feedback');
            element.closest('.form-group').append(error);
        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid');
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid');
        }
    });
  
});